import { render, staticRenderFns } from "./UpdateNegociated.vue?vue&type=template&id=1a9d8e48"
import script from "./UpdateNegociated.vue?vue&type=script&lang=js"
export * from "./UpdateNegociated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports